import { request } from "./request";
import Cookies from "js-cookie";
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, AD_ID_COOKIES_KEY } from "@/utils/constant";
import { getAppID, getFbPixelId } from '@/utils/base'
import { getParam } from '@/utils/tools'
import { getRandomString } from "@/utils/paypal";

export const fetchGetDramaList = (data = {}) => {
  return request({
    url: '/api/v1/drama/list',
    method: "post",
    data: {
      app_id: getAppID(),
      ...data
    }
  })
  // return new Promise((resolve, reject) => {
  //   resolve({
  //     list: [
  //       {
  //         "id": 1,
  //         "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //         "name": "The Revived Me: Surrounded by Adoration as a Supporting Role",
  //         "avatar": "book_avatar/1742469775296607000.jpg",
  //         "author": "Dedaul",
  //         "video_count": 59,
  //         "video_url": "https://www.test.com/video.mp4",
  //         "summary": "In Valerie Horton's previous life",
  //         "category_name": "animation",
  //         "created_at": 1736838554151,
  //         "updated_at": 1736838554211,
  //         "is_fav": 1
  //       },
  //       {
  //         "id": 3,
  //         "uuid": "b24134d6-61f4-4d81-aad4-e88d2512345",
  //         "name": "aldogh qwiealsi paoiunk isihqiux oooasd",
  //         "avatar": "book_avatar/1742469775296607000.jpg",
  //         "author": "Dedaul",
  //         "video_count": 35,
  //         "video_url": "https://www.test.com/video.mp4",
  //         "summary": "In Valerie Horton's previous life",
  //         "category_name": "animation",
  //         "created_at": 1736838554151,
  //         "updated_at": 1736838554211,
  //         "is_fav": 1
  //       }
  //     ]
  //   })
  // })
}


export const fetchGetVideoInfo = (data = {}) => {
    return request({
    url: '/api/v1/drama/detail',
    method: "post",
    data: {
      app_id: getAppID(),
      ...data,
    }
  })

  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       "drama_info": {
  //           "id": 1,
  //           "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //           "name": "The Revived Me: Surrounded by Adoration as a Supporting Role",
  //           "avatar": "book_avatar/1742469775296607000.jpg",
  //           "author": "Dedaul",
  //           "video_count": 59,
  //           "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/affa613d1397757910106230722/v.f100040.mp4?t=683cb872&us=454487&sign=50abf74895456d7937fdf5c158e1dc57",
  //           "summary": "In Valerie Horton's previous life",
  //           "category_name": "animation",
  //           "created_at": 1736838554151,
  //           "updated_at": 1736838554211,
  //           "is_fav": 1
  //       },
  //       "video_list":[
  //           {
  //             "video_number": 1,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/affa613d1397757910106230722/v.f100040.mp4?t=683cb872&us=454487&sign=50abf74895456d7937fdf5c158e1dc57",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 0,
  //           },
  //           {
  //             "video_number": 2,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/696ab3111397757909983045321/v.f100040.mp4?t=683cb872&us=269476&sign=b710ca303c4cfaf398a0482adbab6f8b",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 0,
  //           },
  //           {
  //             "video_number": 3,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/6969a79e1397757909983043669/v.f100040.mp4?t=683cb872&us=688487&sign=77be73503624fd4ecb2ba40278e1500c",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 0,
  //           },
  //           {
  //             "video_number": 4,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/fab4486f1397757910107145698/v.f100040.mp4?t=683cb872&us=442169&sign=98e918dc5fd42e28b4998f0d292eb3d1",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 0,
  //           },
  //           {
  //             "video_number": 5,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/69c2f01d1397757909983091089/v.f100040.mp4?t=683cb872&us=116989&sign=d9053e73ba4e0eabdb609c7e0b538929",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 0,
  //           },
  //           {
  //             "video_number": 6,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/2f632a411397757909982887090/v.f100040.mp4?t=683cb872&us=705134&sign=130a793c028ba916b2b8703137a1fb94",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 1,
  //           },
  //           {
  //             "video_number": 7,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/82c2c6381397757909980082609/v.f100040.mp4?t=683cb872&us=277485&sign=329a271ed8aeddfe4c0ab6a339b6dce8",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 1,
  //           },
  //           {
  //             "video_number": 8,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/e001455f1397757909981776920/v.f100040.mp4?t=683cb872&us=834894&sign=895438717c1b2dd92fe7705be6c937ab",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 1,
  //           },
  //           {
  //             "video_number": 9,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/cf98dfbf1397757909981062986/v.f100040.mp4?t=683cb872&us=935710&sign=d4eb8d08dcde90a873ea694efa9caa4f",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 1,
  //           },
  //           {
  //             "video_number": 10,
  //             "uuid": "b24134d6-61f4-4d81-aad4-e88d25fcd662",
  //             "avatar": "static/img/7adad53e275688858a.jpg",
  //             "video_url": "https://djapi2.2499.net/43bb8b66vodtranscq1500037309/2f4ddc861397757909982871579/v.f100040.mp4?t=683cb872&us=309769&sign=d9320f512816ed76a3b1a6d5b07c9626",
  //             "created_at": 1736838554151,
  //             "updated_at": 1736838554211,
  //             "is_fav": 1,
  //             "view_count":1,
  //             "require_vip": 1,
  //           },
  //       ],
  //       "user_vip_status": 1
  //     })
  //   }, 300);
    
  // })

}

export const fetchGetTmpUuid = function (data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/api/v1/user/tmp_register",
      method: "post",
      isToast: false,
      data:{
        app_id:getAppID(),
        user_type:0
      },
    }).then(response => {
      Cookies.set(USER_ID_COOKIES_KEY, response.token_info.user_id, { expires: 365 })
      Cookies.set(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken, { expires: 365 })
      resolve(response)
    })
  })
}


export const fetchRegister = function (data) {
  return request({
    url: "/api/v1/user/register",
    method: "post",
    data,
  })
}

export const fetchLogin = function (data) {
  return request({
    url: "/api/v1/user/login",
    method: "post",
    data,
  })
}

// 获取档位列表
export const fetchGearList = function (data) {
  return request({
    url: "/api/v1/order/purchase_list",
    method: "post",
    data,
  })
}


export const fetchOrderSubmit = function (data) {
  return request({
    url: "/api/v1/alipay/submit",
    method: "post",
    isToast: false,
    responseType: 'all',
     data: {
      ...data,
      cid: getParam('pid') || '130500',
      cmid: getRandomString()
    },
  })
}

export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchFbReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      fbid: getFbPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      fbp: Cookies.get('_fbp') || "",
      fbc: Cookies.get('_fbc') || "",
    },
    ...data
  }
  if(obj.event === 'pixel_report'){
    if(type === 'PageView'){
      console.log('PageView', getFbPixelId())
      window.fbq('init', getFbPixelId()); 
      window.fbq('track', 'PageView');
    }
  }

  return request({
    url: "/api/v1/report/fb",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}

// 埋点统计上报
export const fetchReportEvent = function (data) {
  return request({
    url: "/api/v1/data/receive",
    method: "post",
    isToast: false,
    data: {
      app_id: getAppID(),
      user_id: Cookies.get(USER_ID_COOKIES_KEY),
      idfp: Cookies.get(AD_ID_COOKIES_KEY) || '', // 传 ad_id
      ...data
    },
  })
}